import { InjectionToken, type Type, type Injector } from '@angular/core';
import type { BulkSelectionPayload } from './bulk-edit.models';

export interface BulkPatchFragment {
  patch?: Record<string, { op: 'set' | 'clear'; value?: unknown }>;
  arrayOps?: Record<string, { op: 'append' | 'remove'; items: unknown[]; closePreviousOpen?: boolean }>;
}

export interface BulkEditSection {
  id: string;
  icon: string;
  titleKey: string;
  priority: number;
  component?: Type<unknown>;
  previewLabelKey: string;
  /** True for array/date-ranged reference fields (teams, skills, roles). */
  appliesToArrayField: boolean;
  supportsClear?: boolean;
  buildPatchFragment(state: unknown, mode?: 'unchanged' | 'set' | 'clear'): BulkPatchFragment;
  visibilityCheck?: (injector: Injector) => boolean;
  editCheck?: (injector: Injector) => boolean;
  /** If true, the action button renders in the error/danger style. */
  danger?: boolean;
  /** If set, clicking this section triggers a direct action instead of opening the bulk edit dialog. */
  directActionHandler?: (selectionPayload: BulkSelectionPayload, injector: Injector, onComplete?: () => void) => void;
}

export function createBulkEditSectionsToken(entityName: string): InjectionToken<BulkEditSection[]> {
  return new InjectionToken<BulkEditSection[]>(`${entityName} Bulk Edit Sections`);
}
